export default function TipsIcon({ svgClass }) {
  return (
    <svg
      className={svgClass}
      viewBox='0 0 50.4 53.2'>
      <g id='Layer_2-2' data-name='Layer 2'>
        <g>
          <path
            className='cls-1'
            d='M25.18,49.88c1.57,0,3.15,0,4.72,0,.23,0,.46,.13,.69,.21-.11,.21-.16,.48-.33,.63-1.03,.96-1.83,2.29-3.42,2.4-1.14,.08-2.29,.09-3.42,0-1.72-.14-2.6-1.56-3.64-2.66-.43-.46,.11-.59,.51-.59,1.63,0,3.26,0,4.89,0h0Z'
            fill='#ffff8b'
          />
          <path
            className='cls-1'
            d='M25.14,43.93c1.8,0,3.61,0,5.41,0,.85,0,1.31,.37,1.3,1.01,0,.63-.48,1.02-1.32,1.02-3.61,0-7.21,0-10.82,0-.86,0-1.29-.37-1.28-1.03,0-.67,.42-1,1.3-1,1.8,0,3.61,0,5.41,0h0Z'
            fill='#ffff8b'
          />
          <path
            className='cls-1'
            d='M25.08,48.94c-1.78,0-3.55,0-5.33,0-.71,0-1.27-.17-1.32-1-.04-.69,.42-1.06,1.34-1.06,3.58,0,7.16,0,10.74,0,.72,0,1.26,.2,1.33,1,.06,.68-.43,1.05-1.35,1.05-1.8,0-3.61,0-5.41,0Z'
            fill='#ffff8b'
          />
          <path
            className='cls-1'
            d='M37,20.03c-2.17-4.78-5.97-7.53-11.23-7.76-5.41-.24-9.52,2.21-12.06,6.98-2.48,4.65-2.11,9.27,.97,13.49,1.89,2.6,3.21,5.23,2.9,8.53-.11,1.19,.51,1.68,1.74,1.68,1.95,0,3.89,0,5.84,0,1.98,0,3.95,0,5.93,0,1.16,0,1.66-.5,1.69-1.67,0-.26,.02-.52,0-.77-.24-2.8,.88-5.11,2.53-7.26,3.11-4.07,3.83-8.51,1.7-13.22Z'
            fill='#ffff8b'
          />
          <rect
            className='cls-1'
            x='0'
            y='24.18'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            fill='#ffff8b'
          />
          <rect
            className='cls-1'
            x='6.15'
            y='9.15'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            transform='translate(10.17 -4.2) rotate(45)'
            fill='#ffff8b'
          />
          <rect
            fill='#ffff8b'
            className='cls-1'
            x='21.17'
            y='2.97'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            transform='translate(29.17 -21.17) rotate(90)'
          />
          <rect
            fill='#ffff8b'
            className='cls-1'
            x='36.16'
            y='9.15'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            transform='translate(75.76 -11.03) rotate(135)'
          />
          <rect
            fill='#ffff8b'
            className='cls-1'
            x='42.39'
            y='24.16'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            transform='translate(92.79 50.38) rotate(-180)'
          />
          <rect
            fill='#ffff8b'
            className='cls-1'
            x='36.19'
            y='39.16'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            transform='translate(40.19 97.03) rotate(-135)'
          />
          <rect
            fill='#ffff8b'
            className='cls-1'
            x='6.16'
            y='39.15'
            width='8'
            height='2.06'
            rx='.87'
            ry='.87'
            transform='translate(-25.43 18.95) rotate(-45)'
          />
        </g>
      </g>
    </svg>
  );
}
